<script>
  import TriggerOption from "../Components/StartTriggers/TriggerOption.svelte";
  import { clickForTriggerSettings } from "../static";
  import { External, M } from '../../external';

  export let add;

  let cmps = [];

  let triggerOptions = [
    "LIST_ADD",
    "LIST_REMOVE",
    "MEMBER_GROUP_ADD",
    "MEMBER_GROUP_REMOVE",
    "TAG_ADD",
    "TAG_REMOVE",
    "PROPERTY_CHANGE",
    "EMAIL_OPEN",
    "EMAIL_CLICK",
    "PURCHASE_MAKE",
    "ORDER_STATUS_CHANGE",
    "CART_ABANDON",
    "GOAL_REACHED",
    "PAGE_VISIT",
    ...(External.Website.communityFeaturesDisabled ? [] : [
      "COMMENT_REACTION",
      "POLL_REACTION"
    ]),
    ...(External.Website.videoFeaturesDisabled ? [] : [
      "VIDEO_STARTED",
      "VIDEO_PORTION_WATCHED",
      "VIDEO_COMPLETED"
    ]),
    ...(External.Website.communityFeaturesDisabled ? [] : [
      "CIRCLE_ENROLL",
      "CIRCLE_CONTENT_COMPLETED"
    ])
  ];

  const onClick = (type) => {
    clickForTriggerSettings(type, null, add);
  };

  $: cmps = cmps.filter((el) => el);
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-25 mb-15">{M.AUTOMATION_TRIGGER_START}</h4>
  <ul>
    {#each triggerOptions as option, index (option)}
      <TriggerOption bind:this={cmps[index]} onClick={() => onClick(option)} bind:type={option} />
    {/each}
  </ul>
</div>
